import { render, staticRenderFns } from "./InkindMatchActivityForm.vue?vue&type=template&id=ff35e3ea&"
import script from "./InkindMatchActivityForm.vue?vue&type=script&lang=js&"
export * from "./InkindMatchActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports